import { useIsMobile } from '@/hooks/use-mobile'
import { TrendingAssetsBaseProps } from './TrendingAssetsBase'
import { TrendingAssetsMobile } from './TrendingAssetsMobile'
import { TrendingAssetsDesktop } from './TrendingAssetsDesktop'

/**
 * Unified TrendingAssets component that renders mobile or desktop version
 * Uses useIsMobile hook to conditionally render the appropriate version
 * This approach separates mobile and desktop code completely
 * 
 * @example
 * ```tsx
 * <TrendingAssets
 *   assets={trendingAssets}
 *   onAssetClick={handleAssetClick}
 *   loading={loading}
 * />
 * ```
 */
export const TrendingAssets = (props: TrendingAssetsBaseProps) => {
  const isMobile = useIsMobile()

  // Completely separate mobile and desktop rendering
  // No CSS classes mixing - pure conditional rendering
  if (isMobile) {
    return <TrendingAssetsMobile {...props} />
  }

  return <TrendingAssetsDesktop {...props} />
}

